import { Item, ItemUpdatePayload } from 'apis/restaurant-api/merchant-admin/menu2/types';

export const buildItemUpdatePayload = (item: Item, imageUrls: string[]): ItemUpdatePayload => ({
  ...item,
  image: imageUrls.length > 0 ? imageUrls[0] : null,
  images: imageUrls.length > 0 ? imageUrls.map(url => ({ url, blurhash: null })) : [],
  source_config: item.source_config?.catalog_country
    ? {
        ...item.source_config,
        field_config: {
          ...item.source_config.field_config,
          images: 'USER_INPUT',
        },
      }
    : null,
});
